"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaFactorRow = void 0;
const ui_1 = require("@app/component/ui");
const setup_mfa_1 = require("@app/component/modals/setup-mfa");
const graphql_1 = require("@app/gql-types/graphql");
const remove_mfa_factor_1 = __importDefault(require("@app/ac/remove-mfa-factor"));
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importDefault(require("react"));
const METHOD_ICONS = {
    [graphql_1.MfaMethods.Email]: ui_1.Icon.ICONS.email,
    [graphql_1.MfaMethods.Sms]: ui_1.Icon.ICONS.phone,
    [graphql_1.MfaMethods.Totp]: ui_1.Icon.ICONS.lock,
};
const MfaFactorRow = ({ factor }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const { addModal } = (0, use_modal_1.useModal)();
    const isRemoving = (0, store_1.useRootSelector)((state) => state.loading.includes('remove-mfa'));
    return (react_1.default.createElement(ui_1.Flex, { align: ui_1.Flex.POSITION.CENTER, justify: ui_1.Flex.POSITION.SPC_BETWEEN, testid: `mfa-factor-row-${factor.type}` },
        react_1.default.createElement(ui_1.Flex, { align: ui_1.Flex.POSITION.CENTER },
            react_1.default.createElement(ui_1.Icon, { ico: METHOD_ICONS[factor.type] }),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8, type: ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, text: (0, util_1.t)(`MFA_METHOD.${factor.type}`) }),
            react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8, type: ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM, color: factor.verified === true ? ui_1.Text.COLORS.GRAY : ui_1.Text.COLORS.DANGER, text: factor.verified === true ? (0, util_1.t)('VERIFIED') : (0, util_1.t)('NOT_VERIFIED') })),
        react_1.default.createElement(ui_1.Flex, { align: ui_1.Flex.POSITION.CENTER },
            factor.verified !== true && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Button, { label: (0, util_1.t)('VERIFY'), testid: `mfa-verify-button-${factor.type}`, onClick: () => addModal(setup_mfa_1.SetupMFA, { mode: 'verify', shouldSendOnLoad: true, type: factor.type }) }),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8, type: ui_1.Spacing.TYPES.HORIZONTAL }))),
            react_1.default.createElement(ui_1.Button, { label: (0, util_1.t)('REMOVE'), color: ui_1.Button.COLORS.RED, disabled: isRemoving, testid: `mfa-remove-button-${factor.type}`, onClick: () => {
                    void dispatch((0, remove_mfa_factor_1.default)({ type: factor.type }));
                } }))));
};
exports.MfaFactorRow = MfaFactorRow;
